import { createFileRoute } from "@tanstack/react-router";
import { CarouselStudio, type Board } from "../features/social-carousel/carousel-studio";

export const Route = createFileRoute("/marrakech-carousel")({
  component: () => <CarouselStudio board={MARRAKECH_BOARD} />,
});

// Stylized "Things to do in Marrakech" board. Hero images are AI-generated
// atmospheric backgrounds (Higgsfield / nano_banana_pro, 4:5) — deliberately
// evocative scenes, not photos of specific real venues, so no factual venue
// claim is implied. Prices are omitted (not published / verifiable here).
const MJ = "https://d8j0ntlcm91z4.cloudfront.net/user_3GQFJTZKy53EBB73EMK8QsmC48K";

const MARRAKECH_BOARD: Board = {
  topLabel: "Marrakech · Morocco",
  kicker: "6 experiences",
  coverLead: "Things to do in",
  coverAccent: "Marrakech",
  subtitle:
    "Agafay desert camps, High Atlas day trips, sunrise balloon flights, Majorelle-blue gardens, medina food walks and traditional hammams.",
  domain: "majourneys.com",
  items: [
    {
      title: "Agafay Desert Experience",
      label: "Desert",
      city: "Marrakech",
      hero: `${MJ}/hf_20260713_125152_f2f4d3dc-059a-4958-ad90-bdbe61cd26a6.png`,
    },
    {
      title: "High Atlas Mountains Day Trip",
      label: "Excursions",
      city: "Marrakech",
      hero: `${MJ}/hf_20260713_125155_74dbeefa-a190-4021-8168-bf76143476d0.png`,
    },
    {
      title: "Sunrise Hot Air Balloon Ride",
      label: "Adventure",
      city: "Marrakech",
      hero: `${MJ}/hf_20260713_125158_7ec2a57c-b532-4ab8-9993-d4b515835367.png`,
    },
    {
      title: "Gardens & Majorelle Blue",
      label: "Culture",
      city: "Marrakech",
      hero: `${MJ}/hf_20260713_125205_00fdc2cc-07a6-46da-b1b0-fac2f6c8d673.png`,
    },
    {
      title: "Medina & Souk Food Walk",
      label: "Food",
      city: "Marrakech",
      hero: `${MJ}/hf_20260713_125208_311e2bee-892e-4db2-9eab-1b32d14ec9eb.png`,
    },
    {
      title: "Traditional Hammam & Spa",
      label: "Wellness",
      city: "Marrakech",
      hero: `${MJ}/hf_20260713_125212_ac5ebbbd-96e7-47c6-bcd9-68df9815a264.png`,
    },
  ],
};
